import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotesStore } from '../store';
import { FileText, Calendar } from 'lucide-react';

export default function TimelineView() {
  const navigate = useNavigate();
  const { notes } = useNotesStore();

  const grouped = notes.reduce((acc, note) => {
    const date = new Date(note.updated_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    if (!acc[date]) acc[date] = [];
    acc[date].push(note);
    return acc;
  }, {});

  return (
    <div className="relative pl-8">
      <div className="absolute left-3 top-0 bottom-0 w-px bg-border" />
      {Object.entries(grouped).map(([date, dateNotes]) => (
        <div key={date} className="mb-8 relative">
          <div className="absolute -left-5 top-0 w-3 h-3 rounded-full bg-primary border-2 border-background" />
          <div className="flex items-center gap-2 mb-3">
            <Calendar size={14} className="text-muted-foreground" />
            <h3 className="text-sm font-medium text-muted-foreground">{date}</h3>
          </div>
          <div className="space-y-2">
            {dateNotes.map(note => (
              <button
                key={note.id}
                onClick={() => navigate(`/note/${note.id}`)}
                className="w-full text-left p-3 bg-card border rounded-lg hover:shadow-md transition-all"
              >
                <div className="flex items-center gap-2">
                  <FileText size={14} className="text-muted-foreground" />
                  <span className="font-medium">{note.title}</span>
                </div>
                {note.content && (
                  <p className="text-sm text-muted-foreground mt-1 line-clamp-2 ml-6">
                    {note.content.replace(/[#*`>\[\]]/g, '').slice(0, 100)}...
                  </p>
                )}
                {note.tags?.length > 0 && (
                  <div className="flex gap-1 mt-2 ml-6">
                    {note.tags.slice(0, 3).map(t => (
                      <span key={t} className="text-xs px-1.5 py-0.5 bg-secondary rounded">{t}</span>
                    ))}
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
